import type { KioskRole } from "./kioskRoles";

/**
 * Le DÉMÉNAGEMENT des chatteurs : dozka.app → cyrano.work.
 *
 * Kayla, 13-10-2026 : « ils ne vont plus aller sur DOZKA Cockpit, ils vont
 * aller sur Cyrano » ; et pour celui qui revient quand même sur dozka.app,
 * « il se rend sur le cockpit, et ça va lui dire d'aller se connecter sur le
 * nouveau […] ça va le rediriger sur la nouvelle URL ».
 *
 * L'heure est la sienne, celle de l'annonce et des messages privés de Francis :
 * mercredi 14 octobre 2026, 8h00 heure de Paris (06:00 UTC). Le cockpit est
 * déployé avant : jusque-là rien ne change.
 *
 * Le CHATTEUR seul (kiosque `chatter`) : le Bureau de Kayla reste sur
 * dozka.app, et cyrano.work n'est que le chatting (13-10, dozka-cockpit#1210).
 *
 * L'heure qui compte est celle où le shell s'est OUVERT, pas l'heure qu'il
 * est : un chatteur du shift A (03h–09h) déjà au travail à 8h00 finit son
 * shift sans être coupé ; le prochain chargement de dozka.app le renvoie.
 */
export const BASCULE_VERS_CYRANO = Date.UTC(2026, 9, 14, 6, 0, 0);

export const ESPACE_CYRANO = "https://cyrano.work";

const DOMAINES_DOZKA = /^(www\.)?dozka\.app$/i;

export function doitDemenager({
  hostname,
  kioskRole,
  ouvertA,
}: {
  hostname: string;
  kioskRole: KioskRole | null;
  ouvertA: number;
}): boolean {
  return (
    kioskRole === "chatter" &&
    DOMAINES_DOZKA.test(hostname) &&
    ouvertA >= BASCULE_VERS_CYRANO
  );
}

/** La même page sur cyrano.work : un lien profond (`?panel=…&conv=…`)
 *  survit au déménagement. */
export function adresseSurCyrano(pathname: string, search: string): string {
  return `${ESPACE_CYRANO}${pathname}${search}`;
}
